export default {
      id: "directions-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#directions",
      toString: function () {
        return this.url;
      }
    }